"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _style = _interopRequireDefault(require("./style.scss"));
var _baseModal = _interopRequireDefault(require("../baseModal"));
var _buttonV = _interopRequireDefault(require("../../buttonV2"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var classKey = 'error-modal';
var CLASS_NAME = _style.default[classKey];
var errorIcon = /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
  className: "error-icon",
  icon: _freeSolidSvgIcons.faTimesCircle
});
var ErrorModal = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(ErrorModal, _PureComponent);
  var _super = _createSuper(ErrorModal);
  function ErrorModal() {
    (0, _classCallCheck2.default)(this, ErrorModal);
    return _super.apply(this, arguments);
  }
  (0, _createClass2.default)(ErrorModal, [{
    key: "renderBody",
    value: function renderBody() {
      return /*#__PURE__*/_react.default.createElement("p", {
        className: "modal-message ".concat(this.props.alignMessage ? "text-align-".concat(this.props.alignMessage) : '')
      }, this.props.message);
    }
  }, {
    key: "renderFooter",
    value: function renderFooter() {
      if (this.props.customFooter !== null) {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "footer-align-".concat(this.props.footerAlign)
        }, this.props.customFooter);
      }
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "modal-footer-button"
      }, /*#__PURE__*/_react.default.createElement(_buttonV.default, {
        muiButtonProps: {
          color: this.props.buttonColor,
          variant: this.props.buttonVariant,
          onClick: this.props.exit
        }
      }, this.props.buttonTitle));
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement(_baseModal.default, {
        backdrop: this.props.backdrop,
        show: this.props.show,
        className: "".concat(CLASS_NAME, " ").concat(this.props.className),
        icon: errorIcon,
        title: this.props.title,
        body: this.renderBody(),
        footer: this.renderFooter(),
        onHide: this.props.onHide || this.props.exit
      });
    }
  }]);
  return ErrorModal;
}(_react.PureComponent);
ErrorModal.propTypes = {
  alignMessage: _propTypes.default.oneOf(['left', 'right', '']),
  backdrop: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.bool]),
  /** Single button variant type */
  buttonVariant: _propTypes.default.oneOf(['contained', 'outlined', 'text']),
  /** Single button color type */
  buttonColor: _propTypes.default.oneOf(['primary', 'secondary', 'success', 'warning', 'inherit', 'info', 'error']),
  /** Single button only */
  buttonTitle: _propTypes.default.string,
  className: _propTypes.default.string,
  /** Replaces `customButton` when multiple elements are necessary */
  customFooter: _propTypes.default.element,
  /** Call to close the dialog with no side effects; single button */
  exit: _propTypes.default.func,
  footerAlign: _propTypes.default.oneOf(['center', 'right', 'left']),
  message: _propTypes.default.string.isRequired,
  onHide: _propTypes.default.func,
  show: _propTypes.default.bool,
  title: _propTypes.default.string
};
ErrorModal.defaultProps = {
  alignMessage: '',
  backdrop: true,
  buttonVariant: 'outlined',
  buttonColor: 'secondary',
  buttonTitle: 'Exit',
  className: '',
  customFooter: null,
  exit: function exit() {
    return null;
  },
  footerAlign: 'center',
  onHide: null,
  show: false,
  title: 'Error'
};
var _default = ErrorModal;
exports.default = _default;